import { createSlice } from "@reduxjs/toolkit";
import uniq from "lodash.uniq";
import uniqBy from "lodash.uniqby";

import { RequestStatus } from "../../../enums/requestStatus";
import { fetchWorkoutTemplates } from "./actions/fetchWorkoutTemplates";
import { removeTemplate } from "./actions/removeTemplate";
import { updateTemplate } from "./actions/updateTemplate";
import { WORKOUT_TEMPLATES_REDUCER_NAME, type WorkoutTemplatesReducer } from "./types";

const initialState: WorkoutTemplatesReducer = {
  list: [],
  listStatus: null,
  tags: [],
  creators: [],
};

const reducerSlice = createSlice({
  initialState,
  name: WORKOUT_TEMPLATES_REDUCER_NAME,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchWorkoutTemplates.pending, (state) => {
      state.listStatus = RequestStatus.FETCHING;
    });
    builder.addCase(fetchWorkoutTemplates.fulfilled, (state, { payload }) => {
      state.listStatus = RequestStatus.SUCCESS;
      state.list = payload;
      if (payload.length) {
        state.tags = uniq(payload.reduce<string[]>((prev, current) => prev.concat(current.tags || []), []));

        state.creators = uniqBy(
          payload.reduce<{ label: string; value: string }[]>((prev, current) => {
            if (current.creator) {
              prev.push({
                label: `${current.creator.firstName} ${current.creator.lastName}`,
                value: current.creator.id,
              });
            }
            return prev;
          }, []),
          "value",
        );
      }
    });
    builder.addCase(fetchWorkoutTemplates.rejected, (state) => {
      state.listStatus = RequestStatus.FAILED;
    });
    builder.addCase(updateTemplate.pending, (state, { meta }) => {
      if (meta.arg.templateId) {
        state.list = state.list.map((template) => {
          if (template.id === meta.arg.templateId) {
            return { ...template, ...meta.arg.template };
          }
          return template;
        });
      }
    });
    builder.addCase(removeTemplate.fulfilled, (state, { payload }) => {
      if (payload) {
        state.list = state.list.filter((template) => template.id !== payload);
      }
    });
  },
});

export default reducerSlice.reducer;
